import { useHover } from '@mantine/hooks';
import { useEffect, useState } from 'react';

// This is to handle the case there the app scrolls off too fast causing the hover
// state to be stuck on, so we have to force it off programmatically.
export const useForcedHover = () => {
  const [forcedHover, setForcedHover] = useState(false);
  const { hovered, ref } = useHover();

  // Reset forceHoverOff when hovered changes
  useEffect(() => {
    if (forcedHover) {
      setForcedHover(false);
    }
  }, [hovered]);

  // If we're in "force off" mode, pretend hovered = false
  return {
    hovered: forcedHover ? false : hovered,
    ref,
    setForcedHover,
  };
};
